import { Routes } from '~/constants/routes';
import { useRouterSelector } from '~/hooks/useRouterSelector';

export const useIsViewingPeoplePageSelector = () => {
  return useRouterSelector((location) => location.pathname.startsWith(Routes.people));
};
